import { IOveralTime } from './skills';

export interface IProfessionalSkill {
  _id?: string;
  overal_time?: IOveralTime;
  self_rating?: string;
  skill?: string;
}

export class ProfessionalSkill implements IProfessionalSkill {
  public _id?: string;
  public overal_time?: IOveralTime;
  public self_rating?: string;
  public skill?: string;

  constructor( profSkill: IProfessionalSkill = {} ) {
    this._id = profSkill._id;
    this.overal_time = profSkill.overal_time || {};
    this.self_rating = profSkill.self_rating;
    this.skill = profSkill.skill;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/professional-skill.ts